import { useMemo } from 'preact/hooks';
import { CompositionDonutChart } from '../charts';
import type { CompositionSlice } from '../../functions/calculations/portfolioCompositionData';
import { useCompositionChartColors } from './compositionChartColors';
import { CompositionPieLegend } from './CompositionPieLegend';

interface CompositionPieViewProps {
  slices: CompositionSlice[];
  /** When true, donut + side legend (used instead of progress bars for small counts). */
  labeled?: boolean;
}

export function CompositionPieView({ slices, labeled = false }: CompositionPieViewProps) {
  const chartColors = useCompositionChartColors();
  const pieChartData = useMemo(
    () =>
      slices.map((slice) => ({
        category: slice.country ? `${slice.name}, ${slice.country}` : slice.name,
        value: slice.value,
      })),
    [slices],
  );

  if (slices.length === 0) {
    return (
      <div className="composition-pie-view composition-pie-view--empty">
        <p>No composition data</p>
      </div>
    );
  }

  if (labeled) {
    return (
      <div className="composition-pie-view composition-pie-view--labeled">
        <div className="composition-pie-view__chart composition-pie-view__chart--donut">
          <div className="composition-donut-frame">
            <CompositionDonutChart
              data={pieChartData}
              colors={chartColors}
              className="composition-donut-chart"
              centerValue={slices.length}
              centerLabel="Groups"
            />
          </div>
        </div>
        <CompositionPieLegend slices={slices} />
      </div>
    );
  }

  return (
    <div className="composition-pie-view">
      <div className="composition-pie-view__chart">
        <CompositionDonutChart
          data={pieChartData}
          colors={chartColors}
          centerValue={slices.length}
          centerLabel="Groups"
        />
      </div>
    </div>
  );
}
